import * as D from './deps';

export function create({ userAuthToken, details }) {
  return D.Api.apiRequest({
    parser: data => {
      if ('pandoraId' in data) {
        return {
          entities: { playlists: { [data.pandoraId]: data } },
          tempPandoraId: data.pandoraId,
        };
      }
      return data;
    },
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_CREATE,
    content: {
      userAuthToken,
      request: {
        details,
      },
    },
  });
}

export function setDetails({ userAuthToken, deviceInfo, request }) {
  return D.Api.apiRequest({
    parser: data => {
      if ('pandoraId' in data) {
        return { entities: { playlists: { [data.pandoraId]: data } } };
      }
      return data;
    },
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_SET_DETAILS,
    content: {
      userAuthToken,
      deviceInfo,
      request,
    },
  });
}

export function annotatePlaylists({ userAuthToken, pandoraIds }) {
  return D.Api.apiRequest({
    parser: data => {
      return { entities: { playlists: data } };
    },
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_ANNOTATE_PLAYLISTS,
    content: {
      userAuthToken,
      request: {
        pandoraIds,
      },
    },
  });
}

export function getTracks({
  userAuthToken,
  pandoraId,
  playlistVersion,
  offset,
  limit,
  annotationLimit,
  allowedTypes,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_GET_TRACKS,
    content: {
      userAuthToken,
      request: {
        pandoraId,
        playlistVersion,
        offset,
        limit,
        annotationLimit,
        allowedTypes,
        bypassPrivacyRules: true,
      },
    },
  });
}

export function editTracks({
  userAuthToken,
  deviceInfo,
  analyticsInfo,
  pandoraId,
  playlistVersion,
  inserts,
  deletes,
  moves,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_EDIT_TRACKS,
    content: {
      userAuthToken,
      deviceInfo,
      request: {
        analyticsInfo,
        pandoraId,
        playlistVersion,
        inserts,
        deletes,
        moves,
      },
    },
  });
}

export function appendItems({
  userAuthToken,
  deviceInfo,
  analyticsInfo,
  pandoraId,
  playlistVersion,
  itemPandoraIds,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_APPEND_ITEMS,
    content: {
      userAuthToken,
      deviceInfo,
      request: {
        analyticsInfo,
        pandoraId,
        playlistVersion,
        itemPandoraIds,
      },
    },
  });
}

export function deleteTracks({
  userAuthToken,
  deviceInfo,
  analyticsInfo,
  pandoraId,
  playlistVersion,
  trackItemIds,
  trackIndexes,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYLISTS_DELETE_TRACKS,
    content: {
      userAuthToken,
      deviceInfo,
      trackIndexes,
      request: {
        analyticsInfo,
        pandoraId,
        playlistVersion,
        trackItemIds,
      },
    },
  });
}

export function getPlaylistRecommendations({
  userAuthToken,
  playlistId,
  addedSongs,
  removedSongs,
  numSongs,
  start,
  annotationLimit,
}) {
  return D.Api.apiRequest({
    parser: data => {
      const songRecommendations = data.songRecommendations;
      const annotations = data.annotations;
      return {
        entities: {
          playlists: {
            [playlistId]: {
              songRecommendations,
              annotations,
            },
          },
        },
      };
    },
    endpoint: D.Constants.Api.ApiEndpoints.PODS_GET_PLAYLIST_SEARCH_RECOMMENDATIONS,
    content: {
      userAuthToken,
      playlistId,
      addedSongs,
      removedSongs,
      numSongs,
      start,
      annotationLimit,
    },
  });
}

export function getPlaylistAutofillTracks({
  userAuthToken,
  playlistId,
  numSongs,
  annotationLimit,
}) {
  return D.Api.apiRequest({
    parser: data => {
      return {
        entities: {
          playlists: {
            [playlistId]: { autoFillSongs: data.songRecommendations },
          },
        },
      };
    },
    endpoint: D.Constants.Api.ApiEndpoints.PODS_GET_PLAYLIST_AUTOFILL_SONGS,
    content: {
      userAuthToken,
      playlistId,
      numSongs,
      annotationLimit,
    },
  });
}
